import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { ru } from './ru';

/**
 * Minimal i18n setup. Russian is the only locale shipped right now;
 * the namespace structure is laid out so that more locales (en/uz/kz)
 * can be plugged in without touching call sites.
 */
i18n.use(initReactI18next).init({
  resources: {
    ru: { translation: ru },
  },
  lng: 'ru',
  fallbackLng: 'ru',
  interpolation: { escapeValue: false },
  returnNull: false,
});

export default i18n;
